module.exports = __webpack_public_path__ + "janne_round-cd3471127afdcd4c2b384971f1a0a16f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/se/janne_round.png
// module id = 1195
// module chunks = 1 2